import { ModalRootContext } from "@redotech/redo-web/modal-root";
import { ExtensionShopifyClient } from "@redotech/shopify-client/ajax";
import { createRoot } from "react-dom/client";
import { ExtendedWarrantyOptions } from ".";
import { RedoShopifyRpcClientContextProvider } from "../../client/redo-shopify-rpc-client";
import { RedoExtendedWarrantyOptionsContainerElement } from "../../extended-warranty/pdp-options/element";
import { RedoRoot } from "../../root";
import { EwSettingsProvider } from "../provider/ew-settings-provider";

export function initialize(
  extensionShopifyClient: ExtensionShopifyClient,
  container?: HTMLElement,
) {
  let shadowHostElement: RedoExtendedWarrantyOptionsContainerElement;
  if (!container) {
    // Rendering via the script tag
    RedoExtendedWarrantyOptionsContainerElement.register();
    shadowHostElement = document.createElement(
      RedoExtendedWarrantyOptionsContainerElement.TAG,
    ) as RedoExtendedWarrantyOptionsContainerElement;
    shadowHostElement.id = "redo-extended-warranty-options-container";
    document.head.append(shadowHostElement);
  } else {
    // Rendering via a shopify block
    RedoExtendedWarrantyOptionsContainerElement.register();
    shadowHostElement = document.createElement(
      RedoExtendedWarrantyOptionsContainerElement.TAG,
    ) as RedoExtendedWarrantyOptionsContainerElement;
    container.append(shadowHostElement);
  }

  const root = createRoot(shadowHostElement.root);
  // TODO: Use a compose wrapper
  root.render(
    <RedoRoot
      extensionShopifyClient={extensionShopifyClient}
      storeUrl={
        globalThis.redoStorefront?.storeUrl ??
        globalThis.Shopify?.shop ??
        globalThis.Shopify?.Checkout?.apiHost
      }
    >
      <ModalRootContext.Provider value={shadowHostElement.modalContainer}>
        <RedoShopifyRpcClientContextProvider
          baseUrl={
            globalThis.redoStorefront?.env?.REDO_SHOPIFY_SERVER_URL ??
            process.env.REDO_SHOPIFY_SERVER_URL!
          }
          storeUrl={
            globalThis.Shopify?.shop ?? globalThis.Shopify?.Checkout?.apiHost
          }
          widgetId={globalThis.redoWidgetId}
        >
          <EwSettingsProvider>
            <ExtendedWarrantyOptions />
          </EwSettingsProvider>
        </RedoShopifyRpcClientContextProvider>
      </ModalRootContext.Provider>
    </RedoRoot>,
  );
}
